/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The type of message a user is allowed to submit for feedback.
 */
export var FeedbackMessageOptions;
(function (FeedbackMessageOptions) {
    FeedbackMessageOptions["MESSAGE"] = "message";
    FeedbackMessageOptions["WELCOME_MESSAGE"] = "welcomeMessage";
    FeedbackMessageOptions["COMPONENT"] = "component";
    FeedbackMessageOptions["CHAT"] = "chat";
})(FeedbackMessageOptions || (FeedbackMessageOptions = {}));
